import { render, staticRenderFns } from "./TotalSales.vue?vue&type=template&id=72feb4d7&scoped=true&"
import script from "./TotalSales.vue?vue&type=script&lang=js&"
export * from "./TotalSales.vue?vue&type=script&lang=js&"
import style0 from "./TotalSales.vue?vue&type=style&index=0&id=72feb4d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72feb4d7",
  null
  
)

export default component.exports